import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default memo(shapeComponent(class ComponentsNotificationTypeAuditTriggersLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    notificationTypeAuditTrigger: instanceOfClassName("NotificationTypeAuditTrigger").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, notificationTypeAuditTrigger, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--notification-type-audit-triggers--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || notificationTypeAuditTrigger.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || notificationTypeAuditTrigger.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, notificationTypeAuditTrigger} = this.p

    if (adminLayout) return Routes.adminNotificationTypeAuditTriggerPath(notificationTypeAuditTrigger.id())
  }
}))
